import React from 'react';
import { ChatCircleIcon, MagnifyingGlassIcon } from '@phosphor-icons/react';
import IconButton from 'components/IconButton';

export default function MobileHeader({
    sidebar,
    setSidebar,
    setSearch,
    search
}) {

    return (
        <div className={`fixed z-[var(--z-nav)] top-0 left-0 bg-black right-0 px-5 pb-3 pt-[max(0.75rem,env(safe-area-inset-top))] lg:hidden flex justify-between gap-10 items-center transition-left duration-300 ease-in-out ${sidebar ? 'left-[80vw]' : 'left-0'} border-b border-transparent`}>
            <IconButton
                tone="dark"
                label={sidebar ? 'Chiudi menu' : 'Apri menu'}
                aria-expanded={sidebar}
                onClick={() => setSidebar(!sidebar)}
            >
                <ChatCircleIcon size={22} className='fill-white' />
            </IconButton>
            <IconButton
                tone="dark"
                label={search ? 'Chiudi ricerca' : 'Cerca'}
                aria-expanded={search}
                onClick={() => setSearch(!search)}
            >
                <MagnifyingGlassIcon size={22} className='fill-white' />
            </IconButton>
        </div>
    )
}
